export const buildStockChartData = (item) => {
  if (!item) return []
  const events = [
    ...(item.purchase_history || []).map((p) => ({ date: new Date(p.date), delta: p.quantity })),
    ...(item.issue_history || []).map((i) => ({ date: new Date(i.date), delta: -i.quantity })),
  ]
  events.sort((a, b) => a.date - b.date)
  let stock = 0
  const result = []
  for (const e of events) {
    stock += e.delta
    result.push({ date: e.date.toISOString().split("T")[0], stock })
  }
  const today = new Date().toISOString().split("T")[0]
  if (item.quantity_available != null) result.push({ date: today, stock: item.quantity_available })
  return result
}

export const buildIssueHistoryData = (item) => {
  if (!item) return []

  if (Array.isArray(item.transactions) && item.transactions.length > 0) {
    return item.transactions.map((row) => ({
      date: row.created_at || row.date,
      type:
        row.type === "purchase"
          ? "Purchase"
          : row.type === "issue"
            ? "Issue"
            : row.type === "return"
              ? "Return"
              : row.type === "adjustment"
                ? (row.adjustment_type ? `Adjustment (${row.adjustment_type})` : "Adjustment")
                : row.type === "unhold"
                  ? "Unhold"
                  : "Hold",
      direction: (Number(row.delta) || 0) >= 0 ? "+" : "-",
      quantity: Math.abs(Number(row.delta) || Number(row.quantity) || 0),
      party: row.metadata?.vendor_name || row.metadata?.issued_to || row.metadata?.customer_name || "—",
      notes: row.notes || row.metadata?.reason || "—",
      transactionId: row._id,
      rawType: row.type,
      issuedQuantity: Number(row.quantity) || 0,
      returnedQuantity: Number(row.returned_quantity) || 0,
      customerId: row.metadata?.customer_id || null,
    }))
  }

  const purchaseRows = (item.purchase_history || []).map((row) => ({
    date: row.date,
    type: "Purchase",
    direction: "+",
    quantity: Number(row.quantity) || 0,
    party: row.vendor_name || row.supplier_name || item.vendor_name || "—",
    notes: row.notes || row.remarks || "—",
  }))

  const issueRows = (item.issue_history || []).map((row) => ({
    date: row.date,
    type: "Issue",
    direction: "-",
    quantity: Number(row.quantity) || 0,
    party: row.issued_to || row.customer_name || "—",
    notes: row.customer_notes || row.notes || "—",
  }))

  return [...purchaseRows, ...issueRows].sort((a, b) => {
    const dateA = a.date ? new Date(a.date).getTime() : 0
    const dateB = b.date ? new Date(b.date).getTime() : 0
    return dateB - dateA
  })
}

export const formatItemDisplayName = (item) => {
  if (!item) return ""
  const primary = item.item_name || ""
  const metadata = [item.brand, item.size].filter(Boolean).join(" | ")
  return metadata ? `${primary} (${metadata})` : primary
}
